module.exports = BD.Model.extend({
    product: BD.belongsTo('Billy.Product', { isParent: true }),
    unitPrice: BD.attr('number'),
    currency: BD.belongsTo('Billy.Currency')
})
